import { PositionerPortal, useCommands, usePositioner } from '@remirror/react';
import { codeBlockPositioner } from './../../utils/code-block-positioner';
import React, { useMemo } from 'react';
import { Select } from 'antd';

const defaultSupportedLanguages = ['javascript', 'json', 'java', 'typescript', 'python', 'jsx', 'tsx', 'html', 'css'];

export const CodeblockLanguageSelector = React.memo(({ supportedLanguages, defaultLanguage, onChange }) => {
  const languages = useMemo(
    () =>
      supportedLanguages.map((lang) => {
        const label = lang.charAt(0).toUpperCase() + lang.slice(1);
        return { value: lang, label: label };
      }),
    []
  );

  return (
    <Select
      className="language-select"
      labelInValue
      defaultValue={defaultLanguage}
      style={{ width: 120 }}
      onChange={onChange}
      options={languages}
    />
  );
});

export const CodeBlockActions = React.memo(({ supportedLanguages, defaultLanguage, onLanguageChange, onDelete }) => {
  return (
    <div className="codeblock-bottom-popover-container">
      <CodeblockLanguageSelector
        supportedLanguages={supportedLanguages}
        defaultLanguage={defaultLanguage}
        onChange={onLanguageChange}
      />
    </div>
  );
});

export const CodeBlockComponent = () => {
  const positioner = usePositioner(codeBlockPositioner, []);
  const { updateCodeBlock } = useCommands();
  const { ref, width, height, x, y, data } = positioner;

  const languages = useMemo(() => {
    return defaultSupportedLanguages;
  }, []);

  const defaultLanguage = useMemo(() => {
    updateCodeBlock({ language: 'json' });
    return 'json';
  }, []);

  const handleLanguageChange = (value) => {
    updateCodeBlock({ language: value.value });
  };

  if (!data) return null;

  const margin = 16;

  return (
    <PositionerPortal>
      <div
        ref={ref}
        style={{
          position: 'absolute',
          left: x,
          top: y + height + margin,
          width: width - 4,
          height: height - 4,
          zIndex: 100,
          pointerEvents: 'none',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
        }}
      >
        <div style={{ zIndex: 100, pointerEvents: 'initial' }}>
          <CodeBlockActions
            supportedLanguages={languages}
            defaultLanguage={defaultLanguage}
            onLanguageChange={handleLanguageChange}
          />
        </div>
      </div>
    </PositionerPortal>
  );
};

export default CodeBlockComponent;
